<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :school="1"
                :title="'학교 방문예약'"
            />
            <div class="content">
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            방문자명
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <el-input class="h48" v-model="name"/>
                    </div>
                </div>
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            연락처
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <phone-input class="h48" v-model="phone"/>
                    </div>
                </div>
                <div class="submit-btn">
                    <button @click="handleSubmit">신청 시작하기</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import GlobalHeader from "@/components/common/GlobalHeader.vue";
import PhoneInput from "@/components/common/PhoneInput.vue";
import { store } from "@/store";
import api from "@/api";
import { ERROR_TYPE } from "@/lib/type";

export default {
    name: "ExternalPersonalInfo",

    data: () => ({
        store,
        name: null,
        phone: null,
    }),

    components: {
        GlobalHeader,
        PhoneInput
    },

    methods: {
        async handleSubmit() {

            // validateion
            if(!this.name || this.name.length < 2) {
                this.$alert.danger({ message: '이름을 2자 이상 입력해주세요.' });
                return;
            }
            if(!this.phone || this.phone.length < 9) {
                this.$alert.danger({ message: '휴대폰 번호를 정확히 입력하세요.' });
                return;
            }

            try {
                const data = {
                    phone: this.phone
                };
                let response = await api.identifySend(data);

                if (response.result === "success") {
                    this.store.visitor = {
                        name: this.name,
                        phone: this.phone,
                    }
                    this.$router.push({ path: `/schools/${store.school.id}/visit/external/auth` });
                } else {
                    throw new Error(response.code);
                }
            } catch (e) {
                this.handleErrorMessage(e);
            }
        },

        async getSchoolInfo(param) {
            try {
                const data = await api.getSchoolInfo(param);
                const {id, name, prof_url} = data;

                this.store.school = {
                    id: id,
                    name: name,
                    prof_url: prof_url
                };

                if(data.available === 0) {
                    this.$router.push({ path: `/schools/${store.school.id}/unused` });
                }

                this.store.available = data.available;
                this.store.available_time = data.available_time;
                this.store.classrooms = data.classrooms;
                this.store.exclusion_date = data.exclusion_date;

            } catch (e) {
                this.handleErrorMessage(e);
            }
        },

        handleErrorMessage(error) {
            let result = null;

            if (typeof error === "object") {
                result = ERROR_TYPE[error.message];
            } else {
                result = ERROR_TYPE[error];
            }

            const message = !result ? "알 수 없는 오류 발생" : result;

            this.$alert.danger({ message });
        },
    },


    created() {
        this.getSchoolInfo(this.$route.params.school);
    },

};
</script>

<style scoped lang="scss">

</style>